"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenewalReactivationPremiumWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var moment = require("moment");
var RenewalReactivationPremiumWidget = /** @class */ (function (_super) {
    __extends(RenewalReactivationPremiumWidget, _super);
    function RenewalReactivationPremiumWidget(props) {
        return _super.call(this, props) || this;
    }
    RenewalReactivationPremiumWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderOutputPanel()));
    };
    RenewalReactivationPremiumWidget.prototype.renderOutputPanel = function () {
        var interaction = this.props.engine.getInteraction();
        var headerInfo = interaction.headerInfo;
        var premiumType = interaction.factors.premiumType;
        return (React.createElement("div", { className: "panel text-center policy-change-price" },
            React.createElement("div", null,
                React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                    (0, commonFunctions_1.getAmountToDisplay)(premiumType === services_1.PREMIUM_TYPE_ANNUAL ? interaction.factors.annualPremium : interaction.factors.monthlyPremium),
                    " to renew your car policy")),
            React.createElement("div", { className: "cover-date" },
                React.createElement("div", null,
                    React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                        "Cover start date",
                        services_1.resourcesHelper.THEME === "Allianz" ? ": " : "")),
                React.createElement("p", null, this.renderCoverStartDate(headerInfo.startDate, "DD MMM YYYY, HH:mm"))),
            React.createElement("div", { className: "cover-date" },
                React.createElement("div", null,
                    React.createElement("p", { className: "font-weight-semi-bold mb-0" },
                        "Cover end date",
                        services_1.resourcesHelper.THEME === "Allianz" ? ": " : "")),
                React.createElement("p", { className: "cover-date" }, (0, commonFunctions_1.convertDate)(interaction.headerInfo.endDate, "DD MMM YYYY, HH:mm"))),
            React.createElement("p", null, "All figures include Insurance Premium Tax")));
    };
    RenewalReactivationPremiumWidget.prototype.renderCoverStartDate = function (startDate, format) {
        if (moment(startDate).isSame(moment(), 'day')) {
            return (0, commonFunctions_1.convertDateToUkTimeZoneDate)(startDate, format);
        }
        else {
            return (0, commonFunctions_1.convertDate)(startDate, format);
        }
    };
    return RenewalReactivationPremiumWidget;
}(plugin_journey_1.WidgetBase));
exports.RenewalReactivationPremiumWidget = RenewalReactivationPremiumWidget;
//# sourceMappingURL=RenewalReactivationPremiumWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/motor/RenewalReactivationPremiumWidget.js
// module id = 3158
// module chunks = 0